<div id="additonalServiceSection">
  <div class="row">
    <div class="col-100 xscol-100 xsmbt15 font18 mtp10">
      <div class="boxst2">
        <h4 translate class="title-h4 mbt10 xsmbt5 text-primary">lblWorkshop</h4>
        <p class="">{{appData.selectedDealer.dealerName}}</p>
        <p class="">{{appData.selectedDealer.address}}</p>
        <p class="">{{appData.selectedDealer.city}} <span *ngIf="appData.selectedDealer.state">,
            {{appData.selectedDealer.state}}</span>
          , {{appData.selectedDealer.country}}
        </p>
        <div class="row">
          <div class="col-50 xscol-100 xsmbt15">
            <h4 translate class="title-h4 mbt10 mtp30 xsmtp10 xsmbt5 text-primary">
              lblRequestedRepairDetails  
            </h4>

            <div width="100%" class="tableborder0" *ngIf="appData">
              <div class="info">
                <div class="lefttitle"><span translate >lblRequestedDate</span>:</div>
                <p><span class="">
                  {{displaySelectedDate |date:'short'}}
                </span>
                </p>
              </div>
              <div class="info">
                <div class="lefttitle">
                  <span translate class="txtright bold inblk">
                    lblYourChoices</span> :
                </div>

                <ul>
                  <li *ngIf="appData.deliverCarWithinBusinessHours != undefined">

                    <span class="break-all" translate
                      *ngIf="appData.deliverCarWithinBusinessHours">lblDeliverInRegularOpeningHours</span>
                    <span class="break-all" translate
                      *ngIf="!appData.deliverCarWithinBusinessHours && !isShareBoxEnable">lblDeliverUsingKeyDrop</span>
                      <span class="break-all" translate
                      *ngIf="!appData.deliverCarWithinBusinessHours && isShareBoxEnable">lblDeliverUsingShareBox</span>

                    </li>
                    <li *ngIf="appData.pickupCarWithinBusinessHours != undefined">

                      <span class="break-all" translate *ngIf="appData.pickupCarWithinBusinessHours">lblPickupInRegularOpeningHours</span>
                      <span class="break-all" translate *ngIf="!appData.pickupCarWithinBusinessHours && !isShareBoxEnable">lblPickupUsingKeyDrop</span>
                      <span class="break-all" translate *ngIf="!appData.pickupCarWithinBusinessHours && isShareBoxEnable">lblPickupUsingShareBox</span>
                    </li>
                    <li *ngIf="appData.isPickupDropOffServiceSelection">
                      <span class="break-all" translate >lblPickUpTime</span>
                      <span>:{{ appData.pickupDatetime | date:'short' }}</span>
                    </li>
                    <li *ngIf="appData.selectedRentalCar">
                      <span class="" translate>lblWantCarHire
                        </span>
                    </li>
                    <li *ngIf="appData.availCheckInFacility==='true'">
                      <span class="" translate>lblOnlineCheckInFacilty
                        </span>
                    </li>
                    <li *ngIf="appData.timeSlotSection"><span class="">
                      <span class="break-all" translate >lblWaitWhileTheCarIsBeingRepaired</span>
                    </span></li>
                </ul>
              </div>

            </div>
            <div class="" *ngIf="appData.pickUpTimeSlot!=null && appData.availCheckInFacility">
              <div class="info">
                <div class="lefttitle"><span translate >lblRequestedDate</span>:</div>
                <p>{{ displaySelectedDate | date:'shortDate' }}
                </p>
              </div>
              <div class="info">
                <div class="lefttitle"><span translate >lblWaitingTime </span></div>
                <p>{{ pickupTimeSlot }}:00
                </p>
              </div>
            </div>

          </div>
          <div class="col-50 xscol-100 xsmbt15">
            <h4 translate class="title-h4 mbt10 mtp30 xsmtp10 xsmbt5 text-primary">lblServices</h4>
            <p class="" *ngFor="let service of appData.selectedService">
              <em class="fas fa-check text-green mrt10"></em> {{service.name}}
              <span *ngIf="service.isDisplayPriceForDealer"><strong class="text-green"> - 
                {{ service.priceIncVat | number:'1.2-2'}}
               </strong></span>
               <span class="d-block pl-4" *ngIf="service.isAdditionalCustomerComment && service.additionalCustomerComment">
                <em class="fa fa-angle-right"></em> <span class="bold" translate>lblAdditionalComment</span> : {{service.additionalCustomerComment}}
              </span>
              
            </p>
            <span class="d-block pl-4" *ngIf="appData.additionalComments">
                <em class="fa fa-angle-right"></em><span class="bold" translate>lblCustomerComment</span> : {{appData.additionalComments}}
              </span>
            <p *ngIf="stonchip?.length"><em class="fas fa-check text-green mrt10"></em> {{stonchip}}</p>
          </div>
        </div>


      </div>
    </div>
    <div class="col-100 mtp40 xscol-100 additional-service" *ngIf="dealerRecommendedService.length > 0">
      <form [formGroup]="additionServicesForm">
        <div class="cst-input-field ">
          <label translate>lblRecommendedAdditionalService</label>
          </div>
        <ul class="listing-st-3 mbt30 xsmbt20">
          <li class="togglesection" *ngFor="let recommendedService of dealerRecommendedService">
            <div class="flex-center space-between nowrap">
              <label class="cst-checkbox mb-0">
                <input type="checkbox" [formControlName]="recommendedService.serviceId.toString()" />
                <span></span>
                {{recommendedService.name}}
              </label>
              <a href="javascript:void(0);" class="flex-grow clrblue mlt15 font16 togglelink flex-center"
                (click)="recommendedService.showDescription = !recommendedService.showDescription"><span translate
                  class="mrt10 xsmrt5">lblViewDetail</span><em class="close-btn"></em></a>
              <div class="clrred font22 bold xsmlt10 smmlt10 mdmlt36">
                {{recommendedService.priceIncVat| number:'1.2-2'}}
              </div>
            </div>
            <div class="togglecontent" *ngIf="recommendedService.showDescription">
              <p>{{recommendedService.description}}</p>
              
            </div>
            <div class="togglecontent" *ngIf="recommendedService.isAdditionalCustomerComment">
              <div class="mtp10 cst-input-field" *ngIf="recommendedService.isAdditionalCustomerComment">
                <label for="" class="font14">{{recommendedService.additionalCustomerCommentTextBoxLabel}}</label>
                <textarea name="" id="" rows="2" [ngModelOptions]="{standalone: true}" maxlength="500"
                [(ngModel)]="recommendedService.additionalCustomerComment" class="form-control"></textarea>
              </div>
            </div>
            <div class="warningLights discription border rounded-3 p-3 mt-2" *ngIf="isWarningLightFeature && recommendedService.isWarningLight">
              <label translate>lblWarningLight<span>:</span></label>
              <div>
                <span class="imgWid d-inline-block position-relative mr-3 bodyIcon" *ngFor="let warninglight of recommendedService.warningLightIdList" 
                [ngClass]="{'selectedWarningLight':warninglight.isSelected }">
                  <img af-image [data-src]="warninglight.Image" [attr.alt]="warninglight.WarningNameName" 
                  [ngClass]="{'disable' : !checkIfServiceSelected(recommendedService.serviceId)}"
                  (click)="onSelectWarningLight(warninglight,recommendedService)" width="70px">
                  <em class="fas fa-check-circle"></em>
                </span>
              </div>
              
            </div>
          </li>
        </ul>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>
  <div class="row">
    <div class="col-100">
      <div class="cst-button-grp mbt20 xsmbt10 fright">
        <button translate aria-label="Center Align" class="btn btn-secondary" (click)="goToPrevious()">
          <em class="pos-relative fa fa-angle-left mr-2"></em> lblBack
        </button>
        <button translate aria-label="Center Align" id="showStep5" class="btn fright btn-primary ml-2" (click)="Onsubmit()">lblConfirmAndNext
          <em class="pos-relative fa fa-angle-right ml-2"></em>
        </button>
      </div>
    </div>
  </div>
</div>